export default {
  data() {
    return {
      isCompleted: false,
    };
  },
};
